import axios from 'axios';
import { setupAuthInterceptor, retryWithBackoff } from '../common';
import { wrapAxiosInstance } from '../cache/modules/axiosFactory';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.pedidos_api.pedidos_modifications;

// Helper function to configure the Axios instance with auth interceptor
const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}));

// Wrap with cache
const cachedApi = wrapAxiosInstance(api, {
  namespace: 'pedidos_api',
  group: 'pedidos_modifications',
  defaultTtl: '1m',
  hashLargeSegments: true,
  emitMeta: true,
});

// /GetAllModificationsByLocalId
export const getAllModificationsByLocalId = async (localId: number) => {
  return await retryWithBackoff(() => 
    cachedApi.get(`/GetAllModificationsByLocalId/${localId}`, undefined, { ttl: '2m' })
  ) as any;
};

// /GetAllModificationsByLocalIdAndRangeDate/<int:local_id>/<string:start_date>/<string:end_date>
export const getAllModificationsByLocalIdAndRangeDate = async (localId: number, startDate: string, endDate: string) => {
  return await retryWithBackoff(() => 
    cachedApi.get(`/GetAllModificationsByLocalIdAndRangeDate/${localId}/${startDate}/${endDate}`, undefined, { ttl: '5m' })
  ) as any;
};


export const getAllModificationsBySessionId = async (sessionId: number) => {
  return await retryWithBackoff(() => 
    cachedApi.get(`/GetAllModificationsBySessionId/${sessionId}`, undefined, { ttl: '2m' })
  ) as any;
}




export const getAllModificationsByLocalIdAndSessionId = async (localId: number) => {
  return await retryWithBackoff(() => 
    cachedApi.get(`/GetAllModificationsByLocalIdAndSessionId/${localId}`, undefined, { ttl: '1m' })
  ) as any;
};
// /GetSummaryByLocalIdAndRangeDate/<int:local_id>/<string:start_date>/<string:end_date>

export const getSummaryByLocalIdAndRangeDate = async (localId: number, startDate: string, endDate: string) => {
  return await retryWithBackoff(() => 
    cachedApi.get(`/GetSummaryByLocalIdAndRangeDate/${localId}/${startDate}/${endDate}`, undefined, { ttl: '5m' })
  ) as any;
};

/**
 * @ns.route('/GetModificationReasons')
class GetModificationReasons(Resource):
    def get(self):
        """
        Returns a JSON object mapping modification reason codes to their descriptions.
        No authentication required as this is reference data.
        """
        modification_reasons = {
            "1": "El cliente pidió por error",
            "2": "El cliente rechazó el plato",
            "3": "El plato no era el correcto",
            "4": "El mesero dañó el plato",
            "5": "El plato llegó muy tarde",
            "6": "El cliente canceló su pedido",
            "7": "Cambio de opinión del cliente",
            "8": "Error en la toma del pedido",
            "9": "Producto no disponible",
            "10": "Cortesía de la casa",
            "11": "Problema de calidad",
            "12": "Alergia o restricción alimentaria",
            "13": "Cierre anticipado de cocina",
            "14": "Otro motivo"
        }
        return modification_reasons, 200
 */

export const getModificationReasons = async () => {
  return await retryWithBackoff(() => 
    cachedApi.get('/GetModificationReasons', undefined, { ttl: '1h' })
  ) as any;
};